import React, { useState } from "react";
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-slate-950/80 shadow-[0_10px_30px_rgba(4,10,20,0.35)] backdrop-blur-xl">
      <div className="container mx-auto flex items-center justify-between px-4 py-3">
        <div className="flex items-center space-x-3">
          <img
            src="/rt-jobspot-logo.svg"
            alt="RT Jobspot Logo"
            className="h-12 w-12 rounded-full object-contain shadow-[0_0_18px_rgba(0,191,212,0.18)] md:h-14 md:w-14"
          />
        </div>

        <nav className="hidden items-center space-x-4 md:flex">
          {["Services", "About", "Contact"].map((item, i) => (
            <a
              key={i}
              href={`#${item.toLowerCase()}`}
              className="relative rounded-lg px-3 py-2 font-medium text-slate-200 transition hover:text-white after:absolute after:-bottom-1 after:left-0 after:h-1 after:w-0 after:bg-secondary after:transition-all after:duration-300 hover:after:w-full"
            >
              {item}
            </a>
          ))}
          <div className="ml-5 flex space-x-2">
            <Link
              to="/creator-registration"
              className="rounded-full border border-secondary/50 bg-white/5 px-5 py-2.5 font-bold text-secondary-light shadow transition hover:scale-105 hover:bg-white/10"
            >
              Creator Registration
            </Link>
            <a
              href="https://rtjobspot.jump2cloud.org/register?uid=1"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-gradient-to-r from-secondary-light to-secondary px-5 py-2.5 font-bold text-slate-950 shadow-lg shadow-secondary/30 transition hover:scale-105 hover:from-secondary hover:to-secondary-light"
            >
              Publisher Sign Up
            </a>
            <a
              href="https://rtjobspot.jump2cloud.org/login"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-white/15 bg-white/5 px-5 py-2.5 font-bold text-white shadow transition hover:scale-105 hover:bg-white/10"
            >
              Publisher Sign In
            </a>
          </div>
        </nav>

        <button
          className="text-white focus:outline-none md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle mobile menu"
          aria-expanded={mobileMenuOpen}
        >
          <svg
            className="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {mobileMenuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="space-y-3 bg-slate-950/95 px-4 pb-4 md:hidden">
          {["Services", "About", "Contact"].map((item, i) => (
            <a
              key={i}
              href={`#${item.toLowerCase()}`}
              className="block border-b border-white/10 py-2 font-medium text-slate-200"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item}
            </a>
          ))}
          <Link
            to="/creator-registration"
            className="mt-2 block w-full rounded-full border border-secondary/50 bg-white/5 px-5 py-2.5 text-center font-bold text-secondary-light"
            onClick={() => setMobileMenuOpen(false)}
          >
            Creator Registration
          </Link>
          <a
            href="https://rtjobspot.jump2cloud.org/register?uid=1"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full rounded-full bg-gradient-to-r from-secondary-light to-secondary px-5 py-2.5 text-center font-bold text-slate-950 shadow-lg shadow-secondary/30"
          >
            Publisher Sign Up
          </a>
          <a
            href="https://rtjobspot.jump2cloud.org/login"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 block w-full rounded-full border border-white/15 bg-white/5 px-5 py-2.5 text-center font-bold text-white"
          >
            Publisher Sign In
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
